<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <v-subheader v-html="directions" v-show="innerShouldShow"></v-subheader>
</template>

<script>
import formMixin from "../formMixin";

export default {
  name: 'TypeDefault',
  mixins: [formMixin],
  props: {
    field: {
      type: Object,
      default: () => {},
    },
  },
  monted() {
    this.fieldLoaded(); // signal to the form we are loaded
  },
  defaults() {
    return {
      label:this.innerLabel,
      directions: this.directions,
      persistentHint: true,
    }
  },
}
</script>
